import React from "react";
import "./ResetPasswordPage.scss";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import ResetPasswordForm from "./ResetPasswordForm.js";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi.js";
import useShowLoader from "../common/loading-widgets/useShowLoader.js";
import Page from "../common/page/Page.js";

export default function ResetPasswordPage() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading, "ResetPasswordPage");

  // RENDER

  return (
    <Page className="ResetPasswordPage">
      <Page.Title loading={tLoading}>{t("authentication-ui:reset_password_title")}</Page.Title>
        <Page.Content>
        <Row>
          <Col className={"reset-password-block-col"}>
            <ResetPasswordBlock />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
}

function ResetPasswordBlock() {
  const { t } = useTranslationAuthenticationUi(useShowLoader);

  // RENDER

  return (
    <div className={"ResetPasswordBlock widget-block"}>
      <Row>
        <Col>
          <p>{t("authentication-ui:reset_password_msg")}</p>
          <ResetPasswordForm />
        </Col>
      </Row>
    </div>
  );
}
